import { render } from "./GoodsTemp.vue?vue&type=template&id=53b31aa2&scoped=true&ts=true"
import script from "./GoodsTemp.vue?vue&type=script&lang=ts"
export * from "./GoodsTemp.vue?vue&type=script&lang=ts"

import "./GoodsTemp.vue?vue&type=style&index=0&id=53b31aa2&scoped=true&lang=less"

import exportComponent from "F:\\freenew\\新建文件夹\\free\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b31aa2"]])

export default __exports__